export default {_name:'icon.fabLike',module:'Field',view:'Element/Icon/FabLike',options:{xs:3}}